var BUTTON_TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TEXT: 'text',
  LINK: 'link'
};
var buttonTypes = ['primary', 'secondary', 'text', 'link'];
var BUTTON_SIZE = {
  S: 's',
  M: 'm',
  L: 'l'
};
var BUTTON_INTENT = {
  DANGER: 'danger',
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info'
};
var BUTTON_VARIANT = {
  DEFAULT: 'variant-default',
  FOCUS: 'variant-focus',
  ACTIVE: 'variant-active',
  DISABLED: 'variant-disabled',
  HOVER: 'variant-hover'
};
var buttonVariants = ['variant-default', 'variant-focus', 'variant-active', 'variant-disabled', 'variant-hover'];

export { BUTTON_INTENT, BUTTON_SIZE, BUTTON_TYPE, BUTTON_VARIANT, buttonTypes, buttonVariants };
//# sourceMappingURL=constants.js.map
